import client from "../api/axios_client";

const authService = {
  login:          (data) => client.post("/auth/login", data),
  forgotPassword: (data) => client.post("/auth/forgot-password", data),
  resetPassword:  (data) => client.post("/auth/reset-password", data),
  me:             ()     => client.get("/auth/me"),
};

export default authService;
